import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "reactstrap";

import { useAuth } from "hooks/useAuth";
import { Exercise } from "components/Exercise";
import { Comments } from "components/Practice/Comments";
import "./exercisePreview.scss";

function ExercisePreview(props) {
  const history = useHistory();
  const { exercises } = useAuth();

  if (!exercises) return <div>Loading...</div>;

  const exercise = exercises.find(x => x.index === props.index);

  if (!exercise) {
    return <div>Exercise not found.</div>;
  }

  return (
    <div className="exercise-preview-container">
      <div className="exercise-preview-navigation">
        <Button onClick={handlePrev}>Prev</Button>
        <Button onClick={handleNext}>Next</Button>
      </div>
      <Exercise
        exercise={Object.assign(exercise, {
          glicko: 1500
        })}
        answer={exercise.answer}
      />
      <Comments show={true} exerciseId={exercise.id} />
    </div>
  );

  function handlePrev() {
    navigateToIndex(Math.max(0, props.index - 1));
  }
  function handleNext() {
    navigateToIndex(props.index + 1);
  }
  function navigateToIndex(index) {
    history.push(`/preview/${index}`);
  }
}

export { ExercisePreview };
